import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { TimeAnimSection } from '../timeAnimSection';
import { gameStore } from '../../store/gameStore';
import { roundTimeStore } from '../../store/roundTimeStore';

export const RoundTimeSection = observer(() => {
  const { isBetsClosed, gameStatus } = gameStore;
  const { time } = roundTimeStore;
  const t = useTranslation();

  const getGameStatus = useMemo(() => {
    if (gameStatus) {
      return t(gameStatus);
    }
    if (time < 2) {
      return t('NO_MORE_BETS');
    }
    return t('PLACE_YOUR_BETS');
  }, [gameStatus, time, t]);

  return (
    <div className='bet-on-poker-loader-block'>
      <TimeAnimSection />
      {((!isBetsClosed && !!time) || gameStatus) && (
        <p className='bet-on-poker-loader-txt'>{getGameStatus}</p>
      )}
    </div>
  );
});
